import { effects } from 'redux-saga'

import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'
import handleViolations from 'internal-components/src/redux/sagas/effects/handleViolations'
import { receiveSignup } from 'internal-components/src/redux/modules/signup/actions'
import {
  addErrors,
  beginWork,
  clearErrors,
  editSignup,
  endWork,
} from '../../modules/signupEdit/actions'

export default function* create({ invocation }, signup) {
  try {
    yield effects.put.resolve(beginWork())
    yield effects.put.resolve(clearErrors())

    const result = yield effects.call(
      callWithHmac,
      invocation.signupCreate,
      signup.get('offer'),
      {
        abn: signup.get('abn'),
        address: signup.get('address'),
        addressLocId: signup.get('addressLocId'),
        billingGroupId: signup.get('billingGroupId'),
        challengePhrase: signup.get('challengePhrase'),
        clientId: signup.get('clientId'),
        companyName: signup.get('companyName'),
        companySize: signup.get('companySize'),
        contact: signup.get('contact'),
        customerReference: signup.customerReference,
        dateOfBirth: signup.get('dateOfBirth')
          ? signup.get('dateOfBirth').format('YYYY-MM-DD')
          : null,
        email: signup.get('email'),
        emailConfirm: signup.get('emailConfirm'),
        firstName: signup.get('firstName'),
        lastName: signup.get('lastName'),
        servicePassword: signup.get('servicePassword'),
        userPassword: signup.get('userPassword'),
        data: signup.get('data').toObject(),
      },
    )

    yield effects.put.resolve(receiveSignup(result.signup))
    yield effects.put.resolve(editSignup(result.signup.id))

    return true
  } catch (e) {
    yield effects.call(handleViolations, e, addErrors)
  } finally {
    yield effects.put.resolve(endWork())
  }

  return false
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/create.js